import { useHasPermissions } from '../../../accessControl/hooks/useHasPermissions';
import { ePermissions } from '../../../../types/administration/userAdministration/ePermissions';
import { useListFeaturesQuery } from '../../../../API/administration/FeaturesAPI';
import { useMemo } from 'react';
import { IFeatureIdentityData } from '../../../../types/administration/features/IFeature';

const featureIdentityComparator = (a: IFeatureIdentityData, b: IFeatureIdentityData) => {
  if (a.name === b.name) {
    return a.identityEmail > b.identityEmail ? 1 : -1;
  }
  return a.name > b.name ? 1 : -1;
};

export const useListFeatureIdentities = () => {
  const hasReadPermission = useHasPermissions([ePermissions.FeatureRead]);
  const {
    data: sortedGlobalFeatures = [],
    error,
    isFetching,
  } = useListFeaturesQuery(undefined, { skip: !hasReadPermission });
  const sortedFeatureIdentityData = useMemo(() => {
    return sortedGlobalFeatures
      .flatMap((feature) => feature.identities)
      .map(({ compositeKey, name, identityId, ...rest }) => ({
        compositeKey: `${name}-${identityId}`,
        name,
        identityId,
        ...rest,
      }))
      .toSorted(featureIdentityComparator);
  }, [sortedGlobalFeatures]);
  return {
    sortedFeatureIdentityData,
    sortedGlobalFeatures,
    featureIdentityError: error,
    isFeatureIdentityFetching: isFetching,
  };
};
